import { useLocation, useNavigate, type NavigateOptions, type To } from 'react-router-dom';

/**
 * Shopify embedded apps rely on query params (shop, host, embedded, etc).
 * React Router navigation drops them by default unless we preserve them.
 */
export function useAppNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return (to: To, options?: NavigateOptions) => {
    // String destinations (most common)
    if (typeof to === 'string') {
      // If caller already provided a query string, keep it.
      const next = to.includes('?') ? to : `${to}${location.search}`;
      return navigate(next, options);
    }

    // Object destinations
    return navigate(
      {
        ...to,
        search: to.search ?? location.search,
      },
      options
    );
  };
}

